
import Vue from 'vue'
import Component from 'vue-class-component'
import WebpartPage from '../components/webpart-page/WebpartPage.vue'

@Component({
    components: { WebpartPage },
})
export default class HomeTestView extends Vue {}
